import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import './key-benefits.css';
import { useTranslation } from 'react-i18next';

const KeyBenefits = (props) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  return (
    <div className={`thq-section-padding ${props.rootClassName} `}>
      <div className='key-benefits-container2 thq-section-max-width'>
        <div className='key-benefits-tabs-menu'>
          <div onClick={() => setActiveTab(0)} className='key-benefits-tab-horizontal1'>
            <div className='key-benefits-divider-container1'>
              {activeTab === 0 && <div className='key-benefits-container3'></div>}
            </div>
            <div className='key-benefits-content1'>
              <h2 className='thq-heading-2'>
                {props.feature1Title ?? (
                  <Fragment>
                    <span className='key-benefits-text35'>{t('keyBenefits.feature1Title')}</span>
                  </Fragment>
                )}
              </h2>
              <span className='thq-body-small'>
                {props.feature1Description ?? (
                  <Fragment>
                    <span className='key-benefits-text11'>{t('keyBenefits.feature1Description')}</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div onClick={() => setActiveTab(1)} className='key-benefits-tab-horizontal2'>
            <div className='key-benefits-divider-container2'>
              {activeTab === 1 && <div className='key-benefits-container4'></div>}
            </div>
            <div className='key-benefits-content2'>
              <h2 className='thq-heading-2'>
                {props.feature2Title ?? (
                  <Fragment>
                    <span className='key-benefits-text24'>{t('keyBenefits.feature2Title')}</span>
                  </Fragment>
                )}
              </h2>
              <span className='thq-body-small'>
                {props.feature2Description ?? (
                  <Fragment>
                    <span className='key-benefits-text17'>{t('keyBenefits.feature2Description')}</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div onClick={() => setActiveTab(2)} className='key-benefits-tab-horizontal3'>
            <div className='key-benefits-divider-container3'>
              {activeTab === 2 && <div className='key-benefits-container5'></div>}
            </div>
            <div className='key-benefits-content3'>
              <h2 className='thq-heading-2'>
                {props.feature3Title ?? (
                  <Fragment>
                    <span className='key-benefits-text10'>{t('keyBenefits.feature3Title')}</span>
                  </Fragment>
                )}
              </h2>
              <span className='thq-body-small'>
                {props.feature3Description ?? (
                  <Fragment>
                    <span className='key-benefits-text25'>{t('keyBenefits.feature3Description')}</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
        <div className='key-benefits-image-container'>
          {activeTab === 0 && (
            <img
              alt={props.feature1ImgAlt}
              src={props.feature1ImgSrc}
              className='key-benefits-image thq-img-ratio-16-9 thq-img-scale thq-img-ratio-4-3'
            />
          )}
        </div>
      </div>
    </div>
  );
};

KeyBenefits.defaultProps = {
  feature3Title: undefined,
  feature1Description: undefined,
  feature2Description: undefined,
  rootClassName: '',
  feature2Title: undefined,
  feature3Description: undefined,
  feature1Title: undefined,
  feature1ImgAlt: 'Fastest notification',
  feature1ImgSrc:
    'https://images.unsplash.com/photo-1533105079780-92b9be482077?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDE1fHx0cmF2ZWx8ZW58MHx8fHwxNzUwMjI3NzA1fDA&ixlib=rb-4.1.0&w=1400',
};

KeyBenefits.propTypes = {
  feature3Title: PropTypes.element,
  feature1Description: PropTypes.element,
  feature2Description: PropTypes.element,
  rootClassName: PropTypes.string,
  feature2Title: PropTypes.element,
  feature3Description: PropTypes.element,
  feature1Title: PropTypes.element,
  feature1ImgAlt: PropTypes.string,
  feature1ImgSrc: PropTypes.string,
};

export default KeyBenefits;
